export default __webpack_public_path__ + "static/media/myallwell_logo.aabec635.svg";